module.exports = __webpack_public_path__ + "img/information-icon1.22f12db5.png";